__webpack_require__.p = "/robot-friends/";